import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from './__generated__/RequestTypesTableQuery$parameters';

type EntryPointProps = {
	projectKey: string;
	cloudId: string;
};

export const requestTypeTableEntrypoint = createEntryPoint({
	root: JSResourceForUserVisible(() =>
		import(
			/* webpackChunkName: "async-request-types-table-view-settings-panel" */
			'./RequestTypesTable.tsx'
		).then((module) => module.RequestTypesTable),
	),
	getPreloadProps: ({ projectKey, cloudId }: EntryPointProps) => {
		return {
			queries: {
				tableSettings: {
					variables: {
						cloudId,
						projectKey,
					},
					parameters,
					options: {
						fetchPolicy: 'store-or-network' as const,
					},
				},
			},
		};
	},
});
